// extracted by mini-css-extract-plugin
export var avatarContainer = "_b9-0";
export var avatarTypingWave = "_b9-i";
export var gray = "_b9-f";
export var green = "_b9-c";
export var icon = "_b9-9";
export var image = "_b9-1";
export var lg = "_b9-6";
export var md = "_b9-5";
export var presenceDot = "_b9-b";
export var red = "_b9-d";
export var sm = "_b9-4";
export var status = "_b9-a";
export var typingDot = "_b9-h";
export var typingPill = "_b9-g";
export var xl = "_b9-7";
export var xs = "_b9-3";
export var xxl = "_b9-8";
export var xxs = "_b9-2";
export var yellow = "_b9-e";